module.exports = __webpack_public_path__ + "static/media/RecomendaIntermediario.b16753f1.png";